import ImageCropper from './ImageCropper';

export default {
  ImageCropper,
};
